import { State } from "@/store/modules/meeting/index";

const setOpenDevicesConfig = (state: State, payload: boolean) => {
  state.openDevicesConfig = payload;
};

const setOpenBackgroundImages = (state: State, payload: boolean) => {
  state.openBackgroundImages = payload;
};

const setSelectedVideoInput = (state: State, payload) => {
  state.selectedVideoInput = payload;
};

const setSelectedAudioInput = (state: State, payload) => {
  state.selectedAudioInput = payload;
};
const setSelectedAudioOutput = (state: State, payload) => {
  state.selectedAudioOutput = payload;
};

const setMeeting = (state: State, payload) => {
  state.meeting = payload;
};

const setAttendee = (state: State, payload) => {
  state.attendee = payload;
};

const setMeetingSession = (state: State, payload) => {
  state.meetingSession = payload;
};

const setCameraEnabled = (state: State, payload: boolean) => {
  state.cameraEnabled = payload;
};

const setMicEnabled = (state: State, payload: boolean) => {
  state.micEnabled = payload;
};

const setColumnDisplay = (state: State, payload: boolean) => {
  state.columnDisplay = payload;
};

const setSharedScreenEnabled = (state: State, payload: boolean) => {
  state.shareScreenEnabled = payload;
};

const setActiveParticipant = (state: State, payload) => {
  state.activeParticipant = payload;
};

const setVideoUrl = (state: State, payload) => {
  state.videoUrl = payload;
};

const setMeetingType = (state: State, payload) => {
  state.meetingType = payload;
};

const setOpenWebinarUrl = (state: State, payload) => {
  state.openWebinarUrl = payload;
};

const setRoomIdWebinarUpdate = (state: State, payload) => {
  state.roomIdWebinarUpdate = payload;
};

const setRoomId = (state: State, payload) => {
  state.roomId = payload;
};

const setWebinarActive = (state: State, payload) => {
  state.webinarActive = payload;
};

const setBackgroundProcessors = (state: State, payload) => {
  state.backgroundProcessors = payload;
};

const setBackgroundIsSupported = (state: State, payload) => {
  state.backgroundIsSupported = payload;
};

const setBackgroundImage = (state: State, payload: string) => {
  localStorage.setItem("background_image", payload);
  state.backgroundImage = payload;
};

const setBackgroundEnabled = (state: State, payload: boolean) => {
  localStorage.setItem("background_enabled", payload.toString());
  state.backgroundEnabled = payload;
};

const setBlurEnabled = (state: State, payload: boolean) => {
  localStorage.setItem("blur_enabled", payload.toString());
  state.blurEnabled = payload;
};

const setBlurAmount = (state: State, payload: number) => {
  localStorage.setItem("blur_amount", payload.toString());
  state.blurAmount = payload;
};

const setBlurProcessors = (state: State, payload) => {
  state.blurProcessors = payload;
};

const setTransformDevice = (state: State, payload) => {
  state.transformDevice = payload;
};

const setBlurIsSupported = (state: State, payload) => {
  state.blurIsSupported = payload;
};

const setVoiceTransformDevice = (state: State, payload) => {
  state.voiceTransformDevice = payload;
};

const setVoiceIsEnabled = (state: State, payload: boolean) => {
  localStorage.setItem("voice_enabled", payload.toString());
  state.voiceIsEnabled = payload;
};

const setVoiceIsSupported = (state: State, payload: boolean) => {
  state.voiceIsSupported = payload;
};

const setPressToTalkEnabled = (state: State, payload: boolean) => {
  state.pressToTalkEnabled = payload;
};

const setUsersInCall = (state: State, payload) => {
  state.usersInCall = payload;
};

const addUsersInCall = (state: State, payload: any) => {
  if (payload.attendeeId && !payload.attendeeId.includes("#content")) {
    const index = state.usersInCall.findIndex((a) => a.id === payload.id);
    if (index < 0) state.usersInCall.push(payload);
    else state.usersInCall.splice(index, 1, payload);
  }
};

const removeUsersInCall = (state: State, payload: string) => {
  if (!payload.includes("#content")) {
    const index = state.usersInCall.findIndex((a) => a.attendeeId === payload);
    state.usersInCall.splice(index, 1);
  }
};

const setIsFirstConnection = (state: State, payload: boolean) => {
  state.isFirstConnection = payload;
};

const setCallIsRecord = (state: State, payload: boolean) => {
  state.callIsRecord = payload;
};

const setActiveGame = (state: State, payload: boolean) => {
  state.activeGame = payload;
};

const setRoomName = (state: State, payload) => {
  state.roomName = payload;
};

const setOpenMeetingUrl = (state: State, payload: boolean) => {
  state.openMeetingrUrl = payload;
};

const setIsVideoUrlLockedByAdmin = (state: State, payload: boolean) => {
  state.isVideoUrlLockedByAdmin = payload;
};

const setLayoutType = (state: State, payload): void => {
  state.layoutType = payload;
};

const setShowCallModal = (state: State, payload: boolean) => {
  state.showCallModal = payload;
};

const setShowCallFromSpaceUser = (state: State, payload) => {
  state.showCallFromSpaceUser = payload;
};

const setFocusMode = (state: State, payload) => {
  state.focusMode = payload;
};

const setCountPlayerInCall = (state: State, payload: number) => {
  state.countPlayerInCall = payload;
};

const setRoomAutoVideoId = (state: State, payload: any) => {
  state.roomAutoVideoId = payload;
};

export default {
  setOpenDevicesConfig,
  setOpenBackgroundImages,
  setSelectedAudioInput,
  setSelectedVideoInput,
  setSelectedAudioOutput,
  setMeeting,
  setAttendee,
  setMeetingSession,
  setCameraEnabled,
  setMicEnabled,
  setColumnDisplay,
  setSharedScreenEnabled,
  setActiveParticipant,
  setVideoUrl,
  setMeetingType,
  setOpenWebinarUrl,
  setRoomIdWebinarUpdate,
  setRoomId,
  setWebinarActive,
  setBackgroundProcessors,
  setBackgroundIsSupported,
  setBackgroundImage,
  setBackgroundEnabled,
  setBlurEnabled,
  setBlurAmount,
  setBlurProcessors,
  setTransformDevice,
  setBlurIsSupported,
  setVoiceTransformDevice,
  setVoiceIsEnabled,
  setVoiceIsSupported,
  setPressToTalkEnabled,
  addUsersInCall,
  removeUsersInCall,
  setUsersInCall,
  setIsFirstConnection,
  setCallIsRecord,
  setActiveGame,
  setRoomName,
  setOpenMeetingUrl,
  setIsVideoUrlLockedByAdmin,
  setLayoutType,
  setShowCallModal,
  setShowCallFromSpaceUser,
  setFocusMode,
  setCountPlayerInCall,
  setRoomAutoVideoId,
};
